const ChatAPI = {
    _api: null,
    get: () => {
        return ChatAPI._api;
    },
    set: api => {
        ChatAPI._api = api;
    }
};

export default ChatAPI;
